<template>
  <div>
    <div>
      <Row
        :gutter="8"
        style="margin: 0px 0 0 0; width: 100%"
        v-if="menus && menus.length > 0"
      >
        <Menu
          mode="horizontal"
          :active-name="menu_name"
          @on-select="selectMenu"
          style="width: 100%"
        >
          <div
            v-for="(v, k) in menus"
            :key="k"
            style="display: inline-block"
            v-auth="v.auth"
          >
            <MenuItem
              :name="v.name"
              @click="v.onClick"
              v-show="v.show === true ? false : true"
            >
              <Badge
                :overflow-count="10000000"
                v-if="v.badge && v.badge.count"
                :count="v.badge.count"
                :offset="[18, -3]"
              >
                {{ v.label }}
              </Badge>
              <span v-if="!(v.badge && v.badge.count)">
                {{ v.label }}
              </span>
            </MenuItem>
          </div>
        </Menu>
      </Row>
    </div>
    <div class="service_box" id="printArea" style="page-break-before: always">
      <div class="service_title">{{ customerName }}服务报告</div>
      <div class="service_nav">
        <div class="service_nav_date noprint">
          <div class="service_nav_date_left">请选择月份：</div>
          <el-date-picker
            v-model="classesDate"
            type="daterange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            :default-time="['00:00:00', '23:59:59']"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            @change="onClassSesDate"
          >
          </el-date-picker>
        </div>
        <div class="service_nav_date_str">
          日期：{{ dayjsS(classesDate[0]).format("YYYY日MM月DD日") }} -
          {{ dayjsS(classesDate[1]).format("YYYY日MM月DD日") }}
        </div>
        <div class="service_nav_right noprint">
          <div class="service_nav_right_email">
            <Button type="info" @click="handleShenpi"> 发送邮箱 </Button>
          </div>
          <div class="service_nav_right_print">
            <Button type="info" v-print="printObject"> 打印 </Button>
          </div>
          <div class="service_nav_right_email">
            <Button type="info" @click="onExport()"> 导出 </Button>
          </div>
        </div>
      </div>
      <div class="service_main">
        <el-table
          :data="tableData"
          style="width: 100%; min-height: calc(100vh - 500px)"
          v-loading="loading"
          element-loading-text="加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        >
          <el-table-column
            type="index"
            :index="indexMethod"
            align="center"
            label="序号"
            width="80"
          >
          </el-table-column>
          <el-table-column prop="name" label="科室" min-width="180">
          </el-table-column>
          <el-table-column
            prop="workTotal"
            align="center"
            label="工单服务"
            min-width="100"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.workTotal ? scope.row.workTotal : 0 }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="facilityTotal"
            align="center"
            label="安装设备数"
            min-width="120"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.facilityTotal ? scope.row.facilityTotal : 0 }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="consumableWorkTotal"
            align="center"
            label="耗材领用"
            min-width="100"
          >
            <template slot-scope="scope">
              <div>
                {{
                  scope.row.consumableWorkTotal
                    ? scope.row.consumableWorkTotal
                    : 0
                }}
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="patrolWorkTotal" align="center" label="巡检工单数量" min-width="120">

                    <template slot-scope="scope">
                        <div>
                            {{ scope.row.patrolWorkTotal ? scope.row.patrolWorkTotal : 0 }}
                        </div>
                    </template>
                </el-table-column> -->
          <el-table-column
            prop="allTotal"
            align="center"
            label="合计服务/次"
            min-width="120"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.allTotal ? scope.row.allTotal : 0 }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="avgTime"
            align="center"
            label="平均时效"
            min-width="100"
          >
            <template slot-scope="scope">
              <div>{{ scope.row.avgTime ? scope.row.avgTime : 0 }}分钟</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="allEvaluation"
            align="center"
            label="满意度"
            min-width="100"
          >
            <template slot-scope="scope">
              <div>
                {{
                  scope.row.allEvaluation
                    ? scope.row.allEvaluation.toFixed(1)
                    : "10.0"
                }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import youxiang from "./youxiang.vue";
import config from "../../../../config";
export default {
  components: {
    youxiang,
  },
  data() {
    return {
      tableData: [],
      list: [],
      menus: [
        {
          label: "服务报告1",
          name: "service_reporting",
          auth: "/admin/reporting/index",
        },
        {
          label: "服务报告2",
          name: "service_reporting_two",
          auth: "/admin/reporting/index",
        },
      ],
      menu_name: "",
      classesDate: "",
      begin: "",
      end: "",
      customerName: "",
      loading: false,
      dayjsS: dayjs,
      printObject: {
        id: "printArea",
        popTitle: window.localStorage.getItem("customerName") + "服务报告",
        manualPageBreak: true,
      },
      pickerOptions: {
        disabledDate: (time) => {
          let current_time =
            dayjs(new Date()).format("YYYY-MM-DD ") + "23:59:59"; //时间日期为：‘当前日期 23:59:59’
          let t = new Date(current_time).getTime(); //‘当前日期 23:59:59’的时间戳
          return time.getTime() > t;
        },
      },
    };
  },
  created() {
    let route = this.$route;
    if (route) {
      this.menu_name = route.name;
    }
    this.classesDate = [
      dayjs().startOf("month").format("YYYY-MM-DD HH:mm:ss"),
      dayjs().format("YYYY-MM-DD HH:mm:ss"),
    ];
    this.begin = dayjs().startOf("month").format("YYYY-MM-DD HH:mm:ss");
    this.end = dayjs().format("YYYY-MM-DD HH:mm:ss");
    this.load();
    this.customerName = window.localStorage.getItem("customerName");
  },

  methods: {
    selectMenu(name) {
      if (this.menu_name !== name) {
        setTimeout(() => {
          this.$destroy();
        }, 100);
        $utils.url.push({ name: name, params: { refresh: true } });
      }
    },
    async onExport() {
      let q = {
        begin: "",
        end: "",
      };
      q.begin = this.begin;
      q.end = this.end;
      this.loading = true;
      let res = await $utils.api.load(
        "/admin/system/htmlPdf/implCountEmail",
        q,
        "get"
      );
      console.log(res);
      if (res.code == 200) {
        window.location.href =
          config.API_HOST + `/admin/common/download?fileName=${res.msg}`;
        this.loading = false;
      }
    },
    //
    handleShenpi(row) {
      this.$Modal.success({
        closable: true,
        title: "发送至邮箱",
        width: "600",
        height: "120px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <youxiang
              begin={this.begin}
              end={this.end}
              onClose={() => this.onClose()}
            >
              {" "}
            </youxiang>
          );
        },
      });
    },
    onClassSesDate(e) {
      this.begin = e[0];
      this.end = e[1];
      this.load();
    },
    async load() {
      let q = {
        begin: "",
        end: "",
        // pageSize: this.pageSize,
        // pageNum: this.pageNum,
      };
      q.begin = this.begin;
      q.end = this.end;
      this.loading = true;
      let res = await $utils.api.load(
        "/admin/statistics/deskCountEmail",
        q,
        "get"
      );
      if (res.code == 200) {
        console.log(res);
        this.loading = false;
        // this.total = res.data.length;
        // let list = res.data
        this.tableData = res.data;
        // let obj = {
        //     name: "Total",
        //     allEvaluation: 0,
        //     allTotal: 0,
        //     avgTime: 0,
        //     consumableWorkTotal: 0,
        //     facilityTotal: 0,
        //     patrolWorkTotal: 0,
        //     ranking: 0,
        //     workTotal: 0
        // }
        // list.forEach(item => {
        //     obj.allEvaluation = (item.allEvaluation ? item.allEvaluation : 10) + obj.allEvaluation
        //     obj.allTotal = (item.allTotal ? item.allTotal : 0) + obj.allTotal
        //     obj.avgTime = (item.avgTime ? item.avgTime : 0) + obj.avgTime
        //     obj.consumableWorkTotal = (item.consumableWorkTotal ? item.consumableWorkTotal : 0) + obj.consumableWorkTotal
        //     obj.facilityTotal = (item.facilityTotal ? item.facilityTotal : 0) + obj.facilityTotal
        //     obj.patrolWorkTotal = (item.patrolWorkTotal ? item.patrolWorkTotal : 0) + obj.patrolWorkTotal
        //     obj.ranking = (item.ranking ? item.ranking : 0) + obj.ranking
        //     obj.workTotal = (item.workTotal ? item.workTotal : 0) + obj.workTotal
        //     obj.patrolWorkTotal = (item.patrolWorkTotal ? item.patrolWorkTotal : 0) + obj.patrolWorkTotal
        // })
        // obj.avgTime = parseInt(obj.avgTime / list.length)
        // obj.allEvaluation = parseInt(obj.allEvaluation / list.length)
        // this.tableData.unshift(obj)
      }
    },
    indexMethod(index) {
      return index;
    },
  },
};
</script>

<style lang="less" media="print">
.service_box {
  // min-height: calc(100vh - 100px);

  .service_title {
    width: 100%;
    font-size: 28px;
    text-align: center;
    font-weight: 800;
  }

  .service_nav {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin: 20px 0;

    .service_nav_date {
      display: flex;
      align-items: center;
      width: 50%;

      .service_nav_date_left {
        margin-right: 10px;
      }

      .el-date-editor .el-range-separator {
        width: 10%;
      }
    }

    .service_nav_date_str {
      display: none;
      font-size: 16px;
    }

    .service_nav_right {
      display: flex;
      width: 40%;
      justify-content: right;
      align-items: center;
      padding: 0 20px;

      .service_nav_right_print {
        font-size: 16px;
        margin-left: 20px;
        margin-right: 20px;
      }
    }
  }

  .el-table tr:nth-child(1) {
    background: #66d4ff;
    font-weight: 600;
  }
}

@page {
  size: auto;
  margin: 3mm;
}

@media print {
  html {
    background-color: #ffffff;
    height: auto !important;
    margin: 0px;
  }

  body {
    border: solid 1px #ffffff;
    margin: 10mm 15mm 10mm 15mm;
  }

  .service_nav_date_str {
    display: block !important;
  }

  #printArea {
    width: 100%;
    // height: 100vh !important;
    overflow: visible !important;
  }

  .service_main {
    width: 100%;
  }

  #printArea table {
    table-layout: auto !important;
  }

  #printArea .el-table tr:nth-child(1) {
    background: #66d4ff !important;
    font-weight: 600;
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
  }

  #printArea .noprint {
    display: none !important;
  }
  // #printArea .el-table--enable-row-transition .el-table__body td.el-table__cell {
  //     background: #66d4ff !important;
  // }

  // #printArea .el-table {
  //     height: 100vh !important;
  // }

  #printArea .el-table__header-wrapper .el-table__header {
    width: 100% !important;
  }

  #printArea .el-table__body-wrapper .el-table__body {
    width: 100% !important;
  }

  #printArea #pagetable table {
    table-layout: fixed !important;
  }
}
</style>
